import React from "react";
import { AppHeader } from "./CommunitySelection";
import Dashboard from "./Dashboard";
import { useLang } from "../lib/i18n";
import { CornerDownRight, ArrowRight, RotateCcw } from "lucide-react";

export const ConsequenceScreen = ({ result, communityName, onContinue, onReconsider, reconsidering, quick = false }) => {
  const { t } = useLang();
  const { consequence, chain_node, completed } = result;
  const state = {
    money_left_this_month: result.money_left_this_month,
    income_this_month: result.income_this_month,
    essentials: result.essentials,
    indicators: result.indicators,
  };
  return (
    <div className="min-h-screen pb-28">
      <AppHeader subtitle={communityName} />
      <div className="max-w-3xl mx-auto px-5 sm:px-6 py-8">
        <div className="animate-rise">
          <div className="bg-white rounded-lg border border-[var(--line)] shadow-sm p-6 sm:p-8">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.14em] font-semibold text-vin bg-vin/5 px-3 py-1.5 rounded-full">
              <CornerDownRight className="w-3.5 h-3.5" strokeWidth={2} />
              {chain_node}
            </div>
            <p className="mt-4 text-lg text-ink leading-relaxed font-body">{consequence}</p>
          </div>

          <div className="mt-6">
            <p className="text-[11px] uppercase tracking-[0.16em] font-semibold text-vin-dark/60 mb-3">
              {t("Where things stand now")}
            </p>
            <Dashboard state={state} quick={quick} />
          </div>
        </div>
      </div>

      <div className="fixed bottom-0 inset-x-0 bg-white/95 border-t border-[var(--line)] backdrop-blur">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 py-4 flex items-center justify-between gap-3">
          <button
            data-testid="reconsider-button"
            onClick={onReconsider}
            disabled={reconsidering}
            className="inline-flex items-center gap-2 text-vin font-semibold px-4 py-3 rounded-full hover:bg-vin/5 transition-colors duration-200 disabled:opacity-40"
          >
            <RotateCcw className="w-4 h-4" strokeWidth={1.75} />
            <span className="hidden sm:inline">{t("Reconsider this decision")}</span>
            <span className="sm:hidden">{t("Reconsider")}</span>
          </button>
          <button
            data-testid="consequence-continue-button"
            onClick={onContinue}
            className="inline-flex items-center gap-2 bg-vin text-white font-semibold px-7 py-3.5 rounded-full hover:bg-vin-hover transition-colors duration-200"
          >
            {completed
              ? (quick ? t("See where this leads") : t("See the year in full"))
              : (quick ? t("Next decision") : t("Next month"))}
            <ArrowRight className="w-5 h-5" strokeWidth={1.75} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsequenceScreen;
